(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bd-product-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bd-guide-bundle')) {
    customElements.define('bd-guide-bundle', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('[data-bundle-form]');
        this.button = this.querySelector('[data-bundle-submit]');
        this.error = this.querySelector('[data-error-message]');
        this.cartLink = this.querySelector('[data-check-cart]');
        this.format = new Intl.NumberFormat('es-ES', { style: 'currency', currency: this.dataset.currency || 'EUR' });
        this.form.addEventListener('change', event => {
          if (event.target.matches('[data-need]')) {
            this.querySelectorAll('[data-choice]').forEach(row => {
              row.hidden = row.dataset.choice !== event.target.value;
              row.querySelector('[data-include]').checked = false;
            });
          }
          this.update();
        });
        this.form.addEventListener('submit', event => this.add(event));
        this.update();
      }
      selectedRows() {
        return [...this.querySelectorAll('[data-buy-item]')].filter(row => !row.hidden && (!row.hasAttribute('data-optional') || row.querySelector('[data-include]').checked));
      }
      variant(row) {
        const input = row.querySelector('[data-variant]');
        const option = input.tagName === 'SELECT' ? input.selectedOptions[0] : input;
        return { id: input.value, price: Number(option?.dataset.price || 0) };
      }
      update() {
        let total = 0;
        let valid = true;
        this.querySelectorAll('[data-buy-item]').forEach(row => {
          const value = this.variant(row);
          if (value.id) row.querySelector('[data-item-price]').textContent = this.format.format(value.price / 100);
        });
        this.selectedRows().forEach(row => {
          const value = this.variant(row);
          if (!value.id) valid = false;
          total += value.price;
        });
        this.querySelector('[data-total]').textContent = this.format.format(total / 100);
        this.button.disabled = !valid || this.busy;
      }
      async add(event) {
        event.preventDefault();
        if (this.busy) return;
        const rows = this.selectedRows();
        if (rows.length > 3 || rows.some(row => !this.variant(row).id)) return;
        this.busy = true;
        this.error.hidden = true;
        this.cartLink.hidden = true;
        this.button.textContent = this.dataset.pending;
        this.update();
        try {
          const response = await fetch(this.dataset.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: rows.map(row => ({ id: Number(this.variant(row).id), quantity: 1 })) }) });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          this.error.textContent = `${this.dataset.error} ${error.message === this.dataset.error ? '' : error.message}`.trim();
          this.error.hidden = false;
          this.cartLink.hidden = false;
          this.error.focus();
        } finally {
          this.busy = false;
          this.button.textContent = this.dataset.label;
          this.update();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
